import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import "./assets/font/iconfont.css";
import "./assets/font/iconmap.css";
import ctx from "./assets/font/woff/ctx";
import 'element-ui/lib/theme-chalk/index.css'
import VueCompositionAPI from '@vue/composition-api'
import bus from "@/assets/js/bus";
import _ from "lodash";
import * as echarts from "echarts";
import {createLocalForage} from "@/utils/localForage"

Vue.use(ElementUI)
Vue.use(VueCompositionAPI)
Vue.prototype.$ctx = ctx.ctx;
Vue.prototype.$bus = bus;
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false

createLocalForage()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
